import bilAPI from "../api";

export const postRegistration = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/registration/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postVerificationCode = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/registration/confirm/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postResendCode = ({ username, purpose }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/auth/resend-code/`, { username, purpose })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
